import filterTypeEnum from "../../../components/Filter/enumerations/filterTypeEnum";
import { filterKeyBetRecordData } from "./filterKeyEnum";

const filterSetupBetRecordData = {
  filter_type: 1,
  quick_search: {
    title: "mobile.betInquiry.username",
    data_index: filterKeyBetRecordData.ACCOUNT,
  },
  // filter_type: 2,
  filters: [
    // {
    //   title: "productReport.gameCategory",
    //   data_index: filterKeyBetRecordData.CATEGORY_ID,
    //   type: filterTypeEnum.SELECT,
    //   columns: 4,
    //   required: true,
    //   data_type: "api",
    // },
    {
      title: "normal.dataTime",
      data_index: [
        filterKeyBetRecordData.START_DATE,
        filterKeyBetRecordData.END_DATE,
      ],
      type: filterTypeEnum.DATE_TIME_RANGE,
      required: true,
      precision: "second",
    },
    {
      title: "normal.brandName",
      data_index: filterKeyBetRecordData.GAME_CODE,
      type: filterTypeEnum.SELECT,
      columns: 4,
      required: true,
      data_type: "api",
    },
    {
      title: "mobile.betInquiry.gameName",
      data_index: filterKeyBetRecordData.GAME_SUB_CODE,
      type: filterTypeEnum.DROPDOWN_SELECT,
      columns: 4,
      required: false,
      data_type: "api",
    },
    // {
    //   type: filterTypeEnum.SELECT,
    //   title: "normal.type",
    //   data_type: "grouped",
    //   data_index: `${filterKeyBetRecordData.GAME_CODE}-${filterKeyBetRecordData.GAME_SUB_CODE}`,
    //   items: [
    //     {
    //       title: "productReport.gameSubCategory",
    //       data_index: filterKeyBetRecordData.GAME_CODE,
    //       type: filterTypeEnum.SELECT,
    //       columns: 4,
    //       required: true,
    //       data_type: "api",
    //     },
    //     {
    //       title: "game",
    //       data_index: filterKeyBetRecordData.GAME_SUB_CODE,
    //       type: filterTypeEnum.SELECT,
    //       columns: 4,
    //       required: false,
    //       data_type: "api",
    //     },
    //   ],
    // },
    {
      title: "mobile.betInquiry.upperLevelAgentAccount",
      data_index: filterKeyBetRecordData.UPPER_ACCOUNT,
      type: filterTypeEnum.INPUT,
      required: false,
    },
  ],
};

export { filterSetupBetRecordData };
